import { useEffect, useState } from 'react';
import { handleError } from '../../../../components/errors/errorHandling';
import { getPaymentAccounts, updatePaymentAccount, PaymentAccount } from '../../../../services/payment/PaymentService';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const usePaymentAccounts = (organizationId?: string) => {
  const [currentOrganizationId, setCurrentOrganizationId] = useState(organizationId);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [currentPaymentAccounts, setCurrentPaymentAccounts] = useState<PaymentAccount[]>();

  useEffect(() => {
    if (!currentOrganizationId) {
      // TODO Set invalid properties
      return;
    }

    setIsLoading(true);
    loadAsync();
  }, [currentOrganizationId]);

  const loadAsync = async () => {
    try {
      const { data } = await getPaymentAccounts(currentOrganizationId);
      setCurrentPaymentAccounts(data);
      setIsLoaded(true);
    } catch (error) {
      handleError(error);
    }
    setIsLoading(false);
  };

  const _updatePaymentAccount = async (organizationId: string, paymentAccount: PaymentAccount) => {
    try {
      const { data } = await updatePaymentAccount(organizationId, paymentAccount);
      return data;
    } catch (error) {
      handleError(error);
    }
  };

  return {
    paymentAccounts: currentPaymentAccounts,
    setPaymentAccounts: setCurrentPaymentAccounts,
    reloadPaymentAccounts: loadAsync,
    updatePaymentAccount: _updatePaymentAccount,
    setOrganizationId: setCurrentOrganizationId,
    isLoading,
    isLoaded,
  };
};

export default usePaymentAccounts;
